/**
 * Date-extensions locale Arabic (Morocco) [ar-ma]
 */
import DateExtended from "../date-extended";
DateExtended.addLocale('ar-ma', {
    monthNames: ['يناير','فبراير','مارس','أبريل','ماي','يونيو','يوليوز','غشت','شتنبر','أكتوبر','نونبر','دجنبر'],
    monthShortNames: ['يناير','فبراير','مارس','أبريل','ماي','يونيو','يوليوز','غشت','شتنبر','أكتوبر','نونبر','دجنبر'],
    dayNames: ['الأحد','الإتنين','الثلاثاء','الأربعاء','الخميس','الجمعة','السبت'],
    dayShortNames: ['احد','اتنين','ثلاثاء','اربعاء','خميس','جمعة','سبت']
});
